import { makeStyles } from "@mui/styles";
import { View } from "../../Base";

const useStyles = makeStyles({
  container: {
    marginTop: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  list: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginTop: "0px",
    paddingLeft: "25px",
  },
});

const PlansList = ({ plans }) => {
  const getPlanType = ({ activeDate, defaultActiveTemplate }) => {
    if (defaultActiveTemplate) return "Daily Plan";
    else if (activeDate) return "Dated Plan";
    else return "Template";
  };
  return plans.map(({ templateName, activeDate, defaultActiveTemplate }) => (
    <li>{`${templateName} - ${getPlanType({
      activeDate,
      defaultActiveTemplate,
    })}`}</li>
  ));
};

export const PostcodeInUseContent = ({ content }) => {
  const styles = useStyles();
  const {
    postcode,
    deliveryPlans = [],
    collectionPlans = [],
    overridePlans = [],
  } = content || {};

  return (
    <View className={styles.container}>
      <View>{`Unable to remove ${postcode} because it is in use by the plans listed below.`}</View>
      {!!deliveryPlans.length && <View>Delivery (Default/Bulk/Smalls):</View>}
      {!!deliveryPlans.length && (
        <ul className={styles.list}>
          <PlansList plans={deliveryPlans} />
        </ul>
      )}
      {!!collectionPlans.length && <View>Collection:</View>}
      {!!collectionPlans.length && (
        <ul className={styles.list}>
          <PlansList plans={collectionPlans} />
        </ul>
      )}
      {!!overridePlans.length && <View>Override:</View>}
      {!!overridePlans.length && (
        <ul className={styles.list}>
          <PlansList plans={overridePlans} />
        </ul>
      )}
    </View>
  );
};
